import { useState } from "react";

export type CurrencyKind = "gold" | "wood" | "stone" | "mana" | "xp" | "shards";

const Fallback: Record<CurrencyKind, string> = {
  gold: "🪙",
  wood: "🪵",
  stone: "🪨",
  mana: "🔮",
  xp: "📜",
  shards: "💎",
};

const Title: Record<CurrencyKind, string> = {
  gold: "Золото",
  wood: "Дерево",
  stone: "Камень",
  mana: "Мана",
  xp: "Hero XP",
  shards: "Soul Shards",
};

// PNG-icon component for in-line currency display. Tries the painterly PNG
// first; if it 404s (the asset hasn't been generated yet) falls back to the
// emoji glyph so the UI never breaks while we wait for art.
export function CurrencyIcon({
  kind,
  size = 14,
  className = "",
}: {
  kind: CurrencyKind;
  size?: number;
  className?: string;
}) {
  const [failed, setFailed] = useState(false);
  if (failed) {
    return (
      <span
        title={Title[kind]}
        className={className}
        style={{ fontSize: size + 2, lineHeight: 1 }}
      >
        {Fallback[kind]}
      </span>
    );
  }
  return (
    <img
      src={`/icons/currency/${kind}.png`}
      alt={Title[kind]}
      title={Title[kind]}
      width={size}
      height={size}
      onError={() => setFailed(true)}
      className={`inline-block align-text-bottom ${className}`.trim()}
      loading="lazy"
    />
  );
}

// Convenience for compact "icon + value" inline pairs.
export function CurrencyValue({
  kind,
  value,
  size = 14,
  className = "",
}: {
  kind: CurrencyKind;
  value: number | string;
  size?: number;
  className?: string;
}) {
  return (
    <span className={`inline-flex items-center gap-0.5 tabular-nums ${className}`.trim()}>
      <CurrencyIcon kind={kind} size={size} />
      {value}
    </span>
  );
}
